import React from 'react'

import EditList from '@productboard/slate-edit-list'

import { createSlug } from 'utils/common'
import BlockActions from '../Components/BlockActions'

import PageIndex from '../ContentElements/PageIndex'
import Hint from '../ContentElements/Hint'
import TableOfContents from '../ContentElements/TableOfContents'
import File from '../ContentElements/File'
import Image from '../ContentElements/Image'
import Gist from '../ContentElements/Gist'
import Codepen from '../ContentElements/Codepen'
import Video from '../ContentElements/Video'
import Divider from '../ContentElements/Divider'
import CodeBlock from '../ContentElements/CodeBlock'

const plugin = EditList({
	types: ['numbered-list', 'bulleted-list'],
	typeItem: 'list-item',
	typeDefault: 'paragraph',
})

// paragraph
// heading-two
// heading-three
// block-quote
// code_block
//     code_line
// bulleted-list
// numbered-list
//     list-item
// hint

// image
// file
// hr

// page-index
// table-of-contents

// youtube
// vimeo
// gist
// codepen

// heading-placeholder
// paragraph-placeholder

const renderBlock = (props, editor, next) => {
	const { attributes, children, node, isSelected, parent } = props

	// if (node.type === "paragraph") {
	//     if (editor.value.blocks.find(block => block === node) {
	//         attrs.className = attrs.className ? attrs.className + " is-focus" : "is-focus";
	//     }
	// }

	const attrs = attributes
	attrs.className = ''

	if (isSelected && props.isFocused && props.parent.object === 'document') {
		attrs.className = attrs.className
			? ` ${attrs.className} has-focus`
			: ' has-focus'
	}

	if (node.type === 'heading-two' || node.type === 'heading-three') {
		// Check if `table-of-contents` is used
		if (
			editor.value.document.nodes.find(
				node => node.type === 'table-of-contents'
			)
		) {
			if (editor && editor.refresh) {
				editor.refresh()
			}
		}
	}

	let rNode

	switch (node.type) {
		case 'code_block':
			rNode = <CodeBlock {...props} attributes={attrs} />

			break
		case 'code_line':
			rNode = <pre {...attributes}>{children}</pre>

			break
		case 'block-quote':
			rNode = <blockquote {...attrs}>{children}</blockquote>

			break
		case 'bulleted-list':
			rNode = <ul {...attrs}>{children}</ul>

			break
		case 'numbered-list':
			rNode = <ol {...attrs}>{children}</ol>

			break
		case 'list-item':
			rNode = <li {...attrs}>{children}</li>

			break
		case 'heading-two':
			rNode = (
				<h2 name={createSlug(node.text)} {...attrs}>
					{children}
				</h2>
			)

			break
		case 'heading-three':
			rNode = (
				<h3 name={createSlug(node.text)} {...attrs}>
					{children}
				</h3>
			)

			break
		case 'paragraph': {
			rNode = <p {...attrs}>{children}</p>

			break
		}
		case 'hr': {
			rNode = <Divider {...props} attributes={attrs} />

			break
		}
		case 'file':
			rNode = <File {...props} attributes={attrs} />

			break
		case 'image':
			rNode = <Image {...props} attributes={attrs} />

			break
		case 'youtube': {
			const { data } = node
			const id = data.get('id')
			const url = `https://youtube.com/embed/${id}`

			rNode = <Video {...props} url={url} attributes={attrs} />

			break
		}
		case 'vimeo': {
			const { data } = node
			const id = data.get('id')
			const url = `https://player.vimeo.com/video/${id}`

			rNode = <Video {...props} url={url} attributes={attrs} />

			break
		}
		case 'draw': {
			const { data } = node
			const url = data.get('url')

			rNode = <Video {...props} url={url} attributes={attrs} />

			break
		}
		case 'figma': {
			const { data } = node
			const shareUrl = encodeURI(data.get('url'))
			const url = `https://www.figma.com/embed?embed_host=share&url=${shareUrl}`

			rNode = <Video {...props} url={url} attributes={attrs} />

			break
		}
		case 'gist':
			rNode = <Gist {...props} attributes={attrs} />

			break
		case 'codepen':
			rNode = <Codepen {...props} attributes={attrs} />

			break
		case 'table-of-contents':
			rNode = <TableOfContents {...props} attributes={attrs} />

			break
		case 'page-index':
			rNode = <PageIndex {...props} attributes={attrs} />

			break
		case 'hint':
			rNode = (
				<Hint {...props} attributes={attrs}>
					{children}
				</Hint>
			)

			break
		case 'heading-placeholder':
			rNode = (
				<h2 {...attrs} className="o-placeholder">
					{children}
				</h2>
			)

			break
		case 'paragraph-placeholder':
			rNode = (
				<p {...attrs} className="o-placeholder">
					{children}
				</p>
			)

			break
		default:
			return next()
		// rNode = <p {...attrs}>{children}</p>
	}

	return (
		<BlockActions {...props} attributes={attrs}>
			{rNode}
		</BlockActions>
	)
}

export default renderBlock
